import { AfterViewInit, Component, OnDestroy, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { Dialog } from "primeng/dialog";
import { FeatureService } from "@app/core/services/feature/feature.service";
/**
 * Component that loads a child route in the main body.
 * It is mainly used in the screens generated by `UI Studio` with navigation of type `Dialog`
 */
@Component({
  selector: "app-screen-dialog",
  templateUrl: "./screen-dialog.component.html"
})
export class ScreenDialogComponent implements AfterViewInit , OnDestroy {
  /**
   * The property to display the dialog if `true`
   */
  displayDialog = true;
  /**
   * Holds the active element when opening a dialog
   */
   activeElement: Element;
  /**
   * Content element
   */
  @ViewChild(Dialog, { static: false }) dialog;
  constructor(private location: Location, private featureService : FeatureService) {}

  ngAfterViewInit(): void {
    this.activeElement = document.activeElement;
    this.featureService.setFocus(this.dialog.el,'button');
  }

  ngOnDestroy(): void {
    (this.activeElement as HTMLElement)?.focus();
  }
  /**
   * Returns to the caller component screen when closing the Dialog
   */
  cancel() {
    this.location.back();
  }
}
